import React, { useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';

const PointsDiv = styled.div`
  position: ${(props) => (props.offerDetailModal ? '' : 'absolute')};
  right: 12px;
  bottom: 13px;
  min-width: 90px;
  height: 32px;
  border-radius: 16.5px;
  background-color: ${(props) =>
    props.isDisabled ? 'gray' : props.theme.primaryButtonBackgroundColor};
  border: none;
  text-align: center;
`;

const PointsText = styled.div`
  color: ${(props) => props.theme.primaryButtonFontColor};
  vertical-align: middle;
  line-height: 32px;
  font-family: ${(props) => props.theme.primaryFontFontFamily};
  padding: 0 10px;
`;

const OfferPoints = ({
  offer,
  disabled,
  modalColor,
  currentPointsBalance,
  offerDetailModal = false,
  setOfferActivateButtonText,
  isOfferDisabled,
  setIsOfferDisabled,
}) => {
  const [pillText, setPillText] = useState('');
  useEffect(() => {
    const points = offer?.offer_details?.points_cost;
    const isEligible = offer?.eligible;
    if (offer?.activated && !offer.auto_redeem) {
      setPillText(
        <i className='fal fa-check' style={{ marginRight: '5px' }} />
      );
      setIsOfferDisabled(false);
      setOfferActivateButtonText('Deactivate Offer');
    } else if (offer.auto_redeem) {
      if (points) {
        if (isEligible) {
          setIsOfferDisabled(false);
          setOfferActivateButtonText('');
          setPillText(
            <span style={{ marginLeft: '5px' }}>
              Automatically Applied • {points} Points
            </span>
          );
        } else {
          setOfferActivateButtonText('');
          setPillText(
            <>
              <i className='far fa-lock' style={{ marginRight: '5px' }} />
              <span style={{ marginLeft: '5px' }}>{points} Points</span>
            </>
          );
        }
      } else {
        if (isEligible) {
          setIsOfferDisabled(false);
          setOfferActivateButtonText('');
          setPillText('Automatically Applied');
        } else {
          setOfferActivateButtonText('');
          setPillText(<i className='far fa-lock' />);
        }
      }
    } else {
      if (points) {
        if (isEligible) {
          setIsOfferDisabled(false);
          setOfferActivateButtonText(`REDEEM FOR ${points} POINTS`);
          setPillText(`Activate • ${points} Points  `);
        } else {
          setOfferActivateButtonText(`REDEEM LATER`);
          setPillText(
            <>
              <i className='far fa-lock' style={{ marginRight: '5px' }} />
              <span style={{ marginLeft: '5px' }}>{points} Points</span>
            </>
          );
        }
      } else {
        if (isEligible) {
          setIsOfferDisabled(false);
          setOfferActivateButtonText('REDEEM NOW!');
          setPillText(`Activate`);
        } else {
          setOfferActivateButtonText('REDEEM LATER');
          setPillText(<i className='far fa-lock' />);
        }
      }
    }
  }, [offer]);

  return (
    <PointsDiv
      disabled={disabled}
      modalColor={modalColor}
      offerDetailModal={offerDetailModal}
      isDisabled={false}
    >
      <PointsText id='OfferPoints-PointsText' isDisabled={isOfferDisabled}>
        {pillText}
      </PointsText>
    </PointsDiv>
  );
};

export default OfferPoints;
